import * as yup from "yup";
import { LOCK_MIN_DURATION, LOCK_MAX_DURATION } from "@/config";

export const LOCK_DURATION_KEY = "duration" as const;

export function useLockValidation() {
    return yup.object().shape({
        [LOCK_DURATION_KEY]: yup
            .number()
            .required()
            .min(LOCK_MIN_DURATION, `Minimum duration is ${LOCK_MIN_DURATION} week`)
            .max(LOCK_MAX_DURATION, `Maximum duration is ${LOCK_MAX_DURATION} weeks`),
    });
}
